import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";

// TODO: This is a temporary solution until we figure out how to use the
//       NotificationService without having to use JSX in non-JSX files.
export const createRestError = (error: any) => {
    NotificationService.error(<RestErrorNotification error={error} />);
};
